export default "__VITE_ASSET__CSWYSn5T__"